import React, { useState, useEffect } from 'react';
import { Container, Typography, CircularProgress, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TrainerSchedule from '../components/TrainerSchedule';
import { fetchAffiliateInfo } from '../api/getClassesApi';

const TrainerSchedulePage = () => {
    const [affiliate, setAffiliate] = useState(null);
    const [trainers, setTrainers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        loadAffiliateData();
    }, []);

    const loadAffiliateData = async () => {
        try {
            // Try to get affiliate from localStorage
            const storedAffiliateId = localStorage.getItem("affiliateId");

            if (!storedAffiliateId) {
                // If no affiliate selected, redirect to trainer page
                navigate('/trainer');
                return;
            }

            // Load affiliate data and trainers using the existing API function
            const data = await fetchAffiliateInfo(storedAffiliateId);

            if (!data) {
                throw new Error('Failed to load affiliate data');
            }

            // The API returns { affiliate, trainers }
            setAffiliate(data.affiliate);
            setTrainers(data.trainers || []);

        } catch (err) {
            console.error("Error loading affiliate data:", err);
            setError("Failed to load schedule data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <Container maxWidth={false} sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                <CircularProgress />
            </Container>
        );
    }

    if (error) {
        return (
            <Container maxWidth={false} sx={{ mt: 4 }}>
                <Alert severity="error">{error}</Alert>
            </Container>
        );
    }

    if (!affiliate) {
        return (
            <Container maxWidth={false} sx={{ mt: 4 }}>
                <Alert severity="warning">
                    No affiliate selected. Please go to the trainer page first.
                </Alert>
            </Container>
        );
    }

    return (
        <Container maxWidth={false} sx={{ mt: 4 }}>
            <Typography variant="h4" gutterBottom>
                Trainer Schedule - {affiliate.name}
            </Typography>
            <TrainerSchedule affiliate={affiliate} trainers={trainers} />
        </Container>
    );
};

export default TrainerSchedulePage;

